import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import { useTheme } from "../../../../context/ThemeContext";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import ChartsWebex from "../../../Webex/Statistics/Charts/ChartsWebex";
import Loader from "../../../../components/Loader";
import { useTranslation } from "react-i18next";

export default function Dashboard({dashboard}) {
    const { apiUrl } = useContext(AuthContext);
    const { theme } = useTheme();
    const [dataForChart, setDataForChart] = useState({devices: {}, threats: {}});
    const [allLabels, setAllLabels] = useState({devices: [], threats: []});
    const { t } = useTranslation();

    useEffect(() => {
        if(dashboard.data) {
            HandleDataForChart(dashboard.data);
        }
    }, [dashboard.data]);

    const HandleDataForChart = (data) => {
        let formattedData = {
            devices: {},
            threats: {}
        };
        let labels = {
            devices: [],
            threats: []
        };
    
        const formatData = (category, dataObject) => {
            if (!dataObject) return;

            Object.entries(dataObject).forEach(([key, value]) => {
                if (key !== "total") {
                    const translatedKey = t(key);
                    const translatedValue = typeof value === "string" ? t(value) : value;
                    
                    formattedData[category][translatedKey] = { [translatedKey]: translatedValue };
                }
            });

            labels[category] = Object.keys(dataObject)
                .filter(key => key !== "total")
                .map(key => t(key));
        };
    
        formatData("devices", data.agents);
        formatData("threats", data.threats);
    
        setAllLabels(labels);
        setDataForChart(formattedData);
    };    

    return (
        <>
            {!dashboard.isLoading && dashboard.data ? (
                <div>
                    <div className="container-bar-statistics">
                        <section>
                            <div className="statistics-number">
                                <div className="statistics-number-title">
                                    <h2>{t("Total des équipements à jour ou obsolète")} :</h2>
                                </div>
                                <div className="statistics-number-total">
                                    {dashboard.data.agents && (
                                        <p>{dashboard.data.agents.total}</p>
                                    )}
                                </div>
                            </div>
                            <div className="statistics-number">
                                <div className="statistics-number-title">
                                    <h2>{t("Total des menaces (résolues et non résolues)")} :</h2>
                                </div>
                                <div className="statistics-number-total">
                                    {dashboard.data.agents && (
                                        <p>{dashboard.data.threats.total}</p>
                                    )}
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className="container-charts">
                    <div className="graphics-statistics-webex-content graphics-statistics-webex-bar">
                        <section className="page-chart-webex">
                        <h2 className="page-chart-webex-title">{t("Nombre de menaces par équipements")}</h2>
                            <ChartsWebex
                                key={theme}
                                dataForChart={dataForChart.devices}
                                allLabels={allLabels.devices}
                                typeOfChart={"bar"}
                                labelTitle={'device'}
                                theme={theme}
                            />
                        </section>
                        <section className="page-chart-webex">
                        <h2 className="page-chart-webex-title">{t('Nombre de menaces par type')}</h2>
                            <ChartsWebex
                                key={theme}
                                dataForChart={dataForChart.threats}
                                allLabels={allLabels.threats}
                                typeOfChart={"bar"}
                                labelTitle={'device'}
                                theme={theme}
                            />
                        </section>
                    </div>
                    </div>
                </div>
            ) : (
                <Loader />
            )}
        </>
    );
}